// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp, FirebaseApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithCredential,
} from "firebase/auth";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
  Messaging,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDzE1Vxchtmr9QiAZbkW9aqhWMRVuq5CP4",
  authDomain: "lookme-192603.firebaseapp.com",
  databaseUrl: "https://lookme-192603.firebaseio.com",
  projectId: "lookme-192603",
  storageBucket: "lookme-192603.appspot.com",
  messagingSenderId: "21833284502",
  appId: "1:21833284502:web:bd196921a2caa0fb063bb7",
  measurementId: "G-DF8814S2F2",
};

// Initialize Firebase App
let app: FirebaseApp;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}

// Initialize Auth
const auth = getAuth(app);

// Initialize Messaging
let messaging: Messaging | null = null;

// Initialize messaging only in browser environment
if (typeof window !== "undefined") {
  isSupported()
    .then((supported) => {
      if (supported) {
        messaging = getMessaging(app);

        // Register the service worker
        if ("serviceWorker" in navigator) {
          navigator.serviceWorker
            .register("/firebase-messaging-sw.js")
            .then((registration) => {
              console.log(
                "Firebase messaging service worker registered:",
                registration
              );
            })
            .catch((error) => {
              console.error(
                "Firebase messaging service worker registration failed:",
                error
              );
            });
        }
      } else {
        console.warn("Firebase Messaging is not supported in this browser");
      }
    })
    .catch((error) => {
      console.error("Error checking Firebase Messaging support:", error);
    });
}

// FCM Token Management
export const getFCMToken = async (): Promise<string | null> => {
  if (!messaging) {
    console.warn("Messaging is not initialized");
    return null;
  }

  try {
    // Get the VAPID key from environment or use the Firebase project key
    const vapidKey =
      process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY ||
      "BEVM2FWO9Pgdj5gvAFEs42gpXdQs-07Rbmw4eegWYBZyaS0xA9eJZta-ehv2y8jGTt7ps9Yp_ticY_o4J6KL-L8";

    const currentToken = await getToken(messaging, {
      vapidKey: vapidKey,
    });

    if (currentToken) {
      return currentToken;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

// Message Listener for foreground messages
export const onMessageListener = (
  callback: (payload: any) => void
): (() => void) => {
  if (!messaging) {
    console.warn("Messaging is not initialized");
    return () => {};
  }

  return onMessage(messaging, (payload) => {
    console.log("Foreground message received:", payload);
    callback(payload);
  });
};

// Delete FCM token
export const deleteFCMToken = async (): Promise<boolean> => {
  if (!messaging) {
    return false;
  }

  try {
    // Note: deleteToken is deprecated in newer versions
    // Token deletion is now handled by unregistering the service worker
    // and clearing local storage
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        if (registration.scope.includes("firebase-messaging-sw.js")) {
          await registration.unregister();
        }
      }
    }
    return true;
  } catch (error) {
    console.error("Error deleting FCM token:", error);
    return false;
  }
};

export { app, auth, messaging, GoogleAuthProvider, signInWithCredential };
